import {
  Button,
  Flex,
  Popover,
  Separator,
  Text,
  TextField,
} from "@radix-ui/themes";
import { useState } from "react";
import toast from "react-hot-toast";
import { updatePreferences } from "@/entities/player";
import { useAppDispatch, useAppSelector } from "@/app/appStore";
import { useMediaPlayer } from "@/shared/ui";

export function Preferences() {
  const preferences = useAppSelector((state) => state.player.preferences);
  const dispatch = useAppDispatch();
  const mediaPlayer = useMediaPlayer();

  const [seekThreshold, setSeekThreshold] = useState(
    String(preferences.seekThreshold)
  );
  const [liveDelayThreshold, setLiveDelayThreshold] = useState(
    String(preferences.liveDelayThreshold)
  );
  const [timeshift, setTimeshift] = useState(
    String(preferences.timeshift || "18000")
  );
  const [padding, setPadding] = useState(String(preferences.padding || "900"));

  const onApply = () => {
    const newPreferences = {
      seekThreshold: Number(seekThreshold),
      liveDelayThreshold: Number(liveDelayThreshold),
      timeshift: Number(timeshift),
    };

    mediaPlayer.updateSettings({
      streaming: {
        delay: {
          liveDelay: newPreferences.liveDelayThreshold,
        },
      },
    });
    dispatch(updatePreferences(newPreferences));
    localStorage.setItem("preferences", JSON.stringify(newPreferences));
    toast.success("Preferences saved");
  };

  const onCancel = () => {
    setSeekThreshold(String(preferences.seekThreshold));
    setLiveDelayThreshold(String(preferences.liveDelayThreshold));
    setTimeshift(String(preferences.timeshift));
  };

  return (
    <Popover.Root>
      <Popover.Trigger>
        <Button variant="ghost" size="1" color="gray">
          Preferences
        </Button>
      </Popover.Trigger>
      <Popover.Content width="300px">
        <Flex direction="column" gap="2">
          <Text as="label" size="1" className="flex items-center gap-2">
            <Text className="basis-28" weight="medium">
              Live delay (s)
            </Text>
            <TextField.Root
              className="grow text-base md:text-xs"
              value={liveDelayThreshold}
              size="1"
              placeholder="Enter number"
              onChange={(e) => setLiveDelayThreshold(e.target.value)}
            ></TextField.Root>
          </Text>

          <Text as="label" size="1" className="flex items-center gap-2">
            <Text className="basis-28" weight="medium">
              Seek amount (ms)
            </Text>
            <TextField.Root
              className="grow text-base md:text-xs"
              value={seekThreshold}
              size="1"
              placeholder="Enter number"
              onChange={(e) => setSeekThreshold(e.target.value)}
            ></TextField.Root>
          </Text>

          <Text as="label" size="1" className="flex items-center gap-2">
            <Text className="basis-28" weight="medium">
              Timeshift (s)
            </Text>
            <TextField.Root
              className="grow text-base md:text-xs"
              value={timeshift}
              size="1"
              placeholder="Enter number"
              onChange={(e) => setTimeshift(e.target.value)}
            ></TextField.Root>
          </Text>

          <Text as="label" size="1" className="flex items-center gap-2">
            <Text className="basis-28" weight="medium">
              Padding (s)
            </Text>
            <TextField.Root
              className="grow text-base md:text-xs"
              value={padding}
              size="1"
              placeholder="Enter number"
              onChange={(e) => setPadding(e.target.value)}
            ></TextField.Root>
          </Text>

          <Separator size="4" />
          <Flex gap="2">
            <Popover.Close>
              <Button className="basis-1/2" size="1" onClick={onApply}>
                Apply
              </Button>
            </Popover.Close>
            <Popover.Close>
              <Button
                className="basis-1/2"
                variant="soft"
                size="1"
                color="gray"
                onClick={onCancel}
              >
                Cancel
              </Button>
            </Popover.Close>
          </Flex>
        </Flex>
      </Popover.Content>
    </Popover.Root>
  );
}
